import { render, staticRenderFns } from "./FPotensiGallery.vue?vue&type=template&id=355755ad&scoped=true"
import script from "./FPotensiGallery.vue?vue&type=script&lang=js"
export * from "./FPotensiGallery.vue?vue&type=script&lang=js"
import style0 from "./FPotensiGallery.vue?vue&type=style&index=0&id=355755ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355755ad",
  null
  
)

export default component.exports